import { useEffect, useRef } from 'react';

import styles from './Confetti.module.css';

import confetti from '../../assets/video/confetti.webm';

export const Confetti = ({ startDelay = 1500 }) => {
  const confettiRef = useRef(null);

  useEffect(() => {
    let idTimeout = '';
    if (confettiRef.current) {
      idTimeout = setTimeout(() => {
        confettiRef.current.play().catch((error) => {});
      }, startDelay);
    } else if (idTimeout) {
      clearTimeout(idTimeout);
    }
    return () => {
      clearTimeout(idTimeout);
    };
  }, []);

  return (
    <video
      style={{ '--startDelay': `${startDelay / 1000}s` }}
      ref={confettiRef}
      muted="muted"
      loop
      playsInline
      className={styles.confetti}
    >
      <source src={confetti} type="video/webm"></source>
    </video>
  );
};
